import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserState } from '../states/user-state';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router, private userState: UserState) {}

  canActivate(): boolean {
    if (!this.userState.getAuthenticated()) {
      this.router.navigate(['/login']);
      return false;
    }

    const user = this.userState.getUser();
    const isAdmin = !!(user?.privilegeLevels?.some(
      (p: { name?: string }) =>
        p?.name === 'Admin' || (typeof p?.name === 'string' && p.name.endsWith('Admin')),
    ));

    if (!isAdmin) {
      this.router.navigate(['/loan/application-list']);
      return false;
    }

    return true;
  }
}
